import { render, staticRenderFns } from "./StaffAdd.vue?vue&type=template&id=7b86f690&"
import script from "./StaffAdd.vue?vue&type=script&lang=js&"
export * from "./StaffAdd.vue?vue&type=script&lang=js&"
import style0 from "./StaffAdd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports